<div class="card">
    <div class="card-body">
        <ngx-spinner name="dialogSpinner" [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium">
            <p style="color: white">Loading ...</p>
        </ngx-spinner>        
        <div class="row">
            <div class="col-md-12">
                <h3>Display & Video 360 audience parameters</h3>
                <section>
                    <mat-button-toggle-group
                        [formControl]="form.controls.newAudienceData"
                        name="newAudienceSelector"
                        aria-label="New audience"
                        (change)="onNewAudienceSelectedChange()">
                        <mat-button-toggle value="0">Existing audience</mat-button-toggle>
                        <mat-button-toggle value="1">New audience</mat-button-toggle>
                    </mat-button-toggle-group>        
                </section>
            </div>
        </div>
        <div class="row">&nbsp;</div>
        <form [formGroup]="form">
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Partners</mat-label>
                        <input 
                            #matAutocompletePartners 
                            name="matAutocompletePartners" 
                            type="text" 
                            placeholder="Pick one" 
                            aria-label="Partner" 
                            matInput
                            [formControl]="form.controls.partnerId" 
                            [matAutocomplete]="auto" 
                            (input)="filterPartners()" 
                            (focus)="filterPartners()" 
                            (click)="resetPartnersFilter()">
                        <mat-autocomplete
                            autoActiveFirstOption
                            #auto="matAutocomplete"
                            [displayWith]="getPartnersDescription.bind(this)"
                            (optionSelected)="onPartnerChange($event)">
                            <mat-option *ngFor="let partner of filteredPartners" [value]="partner.id">{{ partner.name }}</mat-option>
                        </mat-autocomplete>                    
                        <mat-error *ngIf="form.controls.partnerId.errors && (form.controls.partnerId.dirty || form.controls.partnerId.touched)">Partner is required</mat-error>
                    </mat-form-field>   
                </div>
                <div class="col-md-3">
                    <mat-form-field *ngIf="advertisers.length > 0" style="width: 100%;">
                        <mat-label>Advertiser</mat-label>
                        <input
                        #matAutocompleteAdvertisers
                        name="matAutocompleteAdvertisers"
                        type="text"
                        placeholder="Pick one"
                        aria-label="Audience"
                        matInput 
                        [formControl]="form.controls.advertiserId"
                        [matAutocomplete]="auto"
                        (input)="filterAdvertisers()"
                        (focus)="filterAdvertisers()"
                        (click)="resetAdvertisersFilter()">
                        <mat-autocomplete
                            autoActiveFirstOption
                            #auto="matAutocomplete"
                            [panelWidth]="'30vw'"
                            [displayWith]="getAdvertiserDescription.bind(this)"
                            (optionSelected)="onAdvertiserChange($event)">
                            <mat-option *ngFor="let advertiser of filteredAdvertisers" [value]="advertiser.id">
                                {{ advertiser.name && advertiser.name.trim() 
                                ? (advertiser.id + ' - ' + advertiser.name) 
                                : advertiser.id }}
                            </mat-option>
                        </mat-autocomplete>                    
                        <mat-error *ngIf="form.controls.advertiserId.errors && (form.controls.advertiserId.dirty || form.controls.advertiserId.touched)">Advertiser is required</mat-error>
                    </mat-form-field>   
                </div>
                <div class="col-md-3" *ngIf="form.controls.newAudienceData.value == '0'">
                    <mat-form-field *ngIf="!!form.controls.advertiserId.value && audiences.length > 0" style="width: 100%;">
                        <mat-label>Audience</mat-label>
                        <input
                        #matAutocompleteAudiences
                        name="matAutocompleteAudiences"
                        type="text"
                        placeholder="Pick one"
                        aria-label="Audience"
                        matInput 
                        [formControl]="form.controls.audienceId"
                        [matAutocomplete]="auto"
                        (input)="filterAudiences()"
                        (focus)="filterAudiences()"
                        (click)="resetAudiencesFilter()"
                        style="width: 100%;">
                        <mat-autocomplete
                            autoActiveFirstOption
                            #auto="matAutocomplete"
                            [displayWith]="getAudienceDescription.bind(this)"
                            (optionSelected)="onAudienceChange($event)">
                            <mat-option 
                                *ngFor="let audience of filteredAudiences"
                                [value]="audience.id">{{ audience.id }} - {{ audience.name }}</mat-option>
                        </mat-autocomplete>                      
                        <mat-error *ngIf="form.controls.audienceId.errors && (form.controls.audienceId.dirty || form.controls.audienceId.touched)">Audience is required</mat-error>                        
                    </mat-form-field>   
                    <mat-error *ngIf="!!form.controls.advertiserId.value && audiences.length == 0" style="width: 100%;">The advertiser has no AMC audiences</mat-error>
                </div>
                <div class="col-md-3" *ngIf="form.controls.newAudienceData.value == '1' && !!form.controls.advertiserId.value">
                    <mat-form-field style="width: 100%;">
                        <mat-label>New Audience</mat-label>
                        <input 
                            type="text" 
                            placeholder="New Audience"
                            aria-label="New Audience" 
                            matInput
                            [formControl]="form.controls.audienceName">
                        <mat-error
                            *ngIf="form.controls.audienceName.errors && (form.controls.audienceName.dirty || form.controls.audienceName.touched)">
                            Audience is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-3" *ngIf="form.controls.newAudienceData.value == '1' && !!form.controls.advertiserId.value">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Audience type</mat-label>
                        <mat-select [formControl]="form.controls.audienceSubType">
                        <mat-option *ngFor="let t of audienceSubTypes" [value]="t.value">
                            {{ t.label }}
                        </mat-option>
                        </mat-select>
                        <mat-error
                        *ngIf="form.controls.audienceSubType.errors && (form.controls.audienceSubType.dirty || form.controls.audienceSubType.touched)">
                        Audience type is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>      
        </form>
    </div>
</div>

